import { Navigation, Scrollbar } from 'swiper/modules';
import Swiper from 'swiper';

export default function initProjectsSlider(id: string | undefined) {
  function initSliders() {

    const root = document.getElementById(`projects-slider-${id}`);
    if (root) {
      const swiperEl = root.querySelector('.card-swiper') as HTMLElement;
      if (swiperEl) {
        /* eslint-disable no-new */
        new Swiper(swiperEl, {
          modules: [Scrollbar, Navigation],
          slidesPerView: 'auto',
          observer: true,
          observeParents: true,
          scrollbar: {
            el: `#projects-slider-${id} .card-swiper-scrollbar`,
            draggable: true,
            dragClass: 'swiper-scrollbar-drag bg-dark/20! rounded-none! cursor-grab',
          },
          navigation: {
            nextEl: `#projects-slider-${id} .swiper-button-next`,
            prevEl: `#projects-slider-${id} .swiper-button-prev`,
          },
          spaceBetween: 16,
          breakpoints: {
            787: {
              spaceBetween: 30,
            },
          },
        });
      }
    }
  }

  initSliders();
}
